<template>
    <div v-loading="loading">
        <div class="search-ctn" style="padding-top: 0; padding-left: 10px; padding-right: 10px">
            <div class="search-name">标签码：{{ LabelData.LabelCode }}</div>
            <div class="search-name">商品名称：{{ LabelData.GoodsName }}</div>
            <div class="search-name">商品编码：{{ LabelData.APCode }}</div>
            <div class="tooMuchAS">适用车型：{{ LabelData.AutoSerise }}</div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="dataList"
                border=""
                style="width: 100%; margin-bottom: 10px"
                min-height="530px"
            >
                <el-table-column fixed show-overflow-tooltip label="操作类型" prop="OpTypeName">
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="200" prop="Remark" label="操作说明">
                    <template slot-scope="scope">
                        <span
                            class="btnSpan"
                            v-if="checkk(scope.row) && scope.row.ObjId"
                            @click="gotoDetails(scope.row)"
                        >{{scope.row.Remark}}</span>
                        <span v-else>{{scope.row.Remark}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="160" prop="CreateTime" label="操作时间"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="Oper" label="操作人"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
  name: "",
  props: ["LabelId"],
  components: {},
  data() {
    return {
      loading: false,
      dataList: [],
      LabelData: {},
      jumpTag: [5, 6, 8, 10, 19, 20, 21, 22, 23, 25]
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let that = this;
      that.loading = true;
      that.$util
        .axiosGet({
          url: "/api/EntpGoodsLabels/GetGoodsLabelLifes",
          data: { LabelId: that.LabelId }
        })
        .then(res => {
          that.LabelData = res.data;
          if (res.data.DataList) {
            that.dataList = res.data.DataList;
          }
          that.loading = false;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    gotoDetails(row) {
      if (row.ObjId) {
        switch (row.OpType) {
          case 0:
            if (row.Remark.indexOf("【ZZ") != -1) {
              this.$router.push(
                `/inventoryManage/goods/sets/setOrderEdit?type=1&SetOrderId=${
                  row.ObjId
                }`
              );
            } else if (row.Remark.indexOf("【CG") != -1) {
              //去采购
              this.$router.push(
                `/purchaseManage/purchaseOrders/check?id=${row.ObjId}`
              );
            }

            break;
          case 5:
            this.$router.push(`/salesManage/salesOrder/check?id=${row.ObjId}`);
            break;
          case 6:
            this.$router.push(
              `/inventoryManage/goods/sets/setOrderEdit?type=1&SetOrderId=${
                row.ObjId
              }`
            );
            break;
          case 8:
            this.$router.push(
              `/inventoryManage/salesReturns/takeIn/edit?type=1&SReturnId=${
                row.ObjId
              }&id=`
            );
            break;
          case 10:
            this.$router.push(
              `/inventoryManage/checkInventory/edit?type=1&InvensId=${
                row.ObjId
              }`
            );
            break;
          case 19:
          case 20:
          case 23:
            this.$router.push(
              `/inventoryManage/goods/sets/setOrderEdit?type=1&SetOrderId=${
                row.ObjId
              }`
            );
            break;
          case 21:
          case 22:
          case 25:
            this.$router.push(
              `/inventoryManage/transWarehouse/edit?type=1&TOId=${row.ObjId}`
            );
            break;
        }
      }
    },
    checkk(item) {
      if (
        item.OpType == 0 &&
        (item.Remark.indexOf("【ZZ") != -1 || item.Remark.indexOf("【CG") != -1)
      )
        return true;

      if (this.jumpTag.includes(item.OpType)) return true;
    }
  }
};
</script>
<style lang="less" scoped>
.tooMuchAS {
  margin: 0 10px 10px;
  line-height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-height: 32px;
  -webkit-box-orient: vertical;
  min-height: 32px;
}
.btnSpan {
  cursor: pointer;
  color: #409eff;
}
</style>
